/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Design System Hooks
 *
 * Barrel export for all design system-related hooks
 */

// Export hooks
export { useColorScale } from "./use-color-scale";
export { useDesignTokens } from "./use-design-tokens";
export { useDynamicColors } from "./use-dynamic-colors";
export { useSemanticSurface } from "./use-semantic-surface";
export { useSemanticSurfaces } from "./use-semantic-surfaces";
export { useSurfacePalette } from "./use-surface-palette";
export { useSurfaceStyles } from "./use-surface-styles";

// Export types from use-design-tokens
export type {
  SemanticIntent,
  SemanticInteractionColors,
  SemanticSurfaceColors,
  SemanticSurfaceShadeConfig,
  SurfaceContext,
} from "./use-design-tokens";

// Export types from use-semantic-surfaces
export type { SemanticSurfaces } from "./use-semantic-surfaces";

// Export types from types file
export type { TokenShade } from "./types";
